import {BaseResponseDTO} from "./base.response.dto";
import {DetalleJornadaDTO} from "../detalleJornada.dto";


export class GetDetalleJornadaResponseDTO extends BaseResponseDTO {

  success: boolean;
  msg: string;
  data: DetalleJornadaDTO;

}
